import PropTypes from 'prop-types';
import { isString, endsWith } from 'lodash';

const resolveSize = (size) => {
  if (isString(size) && endsWith(size, 'px')) return size.slice(0, -2);
  return size;
};

export const marginPropType = PropTypes.oneOfType([
  PropTypes.bool,
  PropTypes.array,
  PropTypes.number,
]);

export function marginResolver(
  enterMargin,
): null | { top: any; left: any; right: any; bottom: any } {
  if (!enterMargin) return null;
  const margin = (Array.isArray(enterMargin) ? enterMargin : [enterMargin]).map(
    (m) => resolveSize(m.size),
  );
  switch (margin.length) {
    case 1:
      return {
        top: margin[0],
        right: margin[0],
        bottom: margin[0],
        left: margin[0],
      };
      break;
    case 2:
      return {
        top: margin[0],
        right: margin[1],
        bottom: margin[0],
        left: margin[1],
      };
      break;
    case 3:
      return {
        top: margin[0],
        right: margin[1],
        bottom: margin[2],
        left: margin[1],
      };
      break;
    case 4:
      return {
        top: margin[0],
        right: margin[1],
        bottom: margin[2],
        left: margin[3],
      };
      break;
    default:
      return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      };
      break;
  }
}

export function marginCssResolver(propName = 'margin') {
  return (props) => {
    const margins = marginResolver(props[propName]);
    if (!margins) return {};

    return {
      marginTop: `${margins.top}px`,
      marginBottom: `${margins.bottom}px`,
      marginLeft: `${margins.left}px`,
      marginRight: `${margins.right}px`,
    };
  };
}
